import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MixedFeed, BannerText } from '@yes/components';
import SelectionContent from '../scripts/components/SelectionContent';
class EntertainmentView extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { className, adContentId, context, tiles, personalityData } = this.props;

        if (personalityData) {
            return (
                <div className={className}>
                    <div className={`section__container ${context}-container`}>
                        <SelectionContent
                            className={`${context}`}
                            adContentId={`${adContentId}`}
                            selectionData={personalityData}
                        />
                    </div>
                </div>
            );
        }

        return (
            <div className={className}>
                <div className={`section__container ${context}-container`}>
                    <MixedFeed title={context} mediaItems={tiles} />
                    {context === 'shows' && (
                        <BannerText
                            headline={
                                'CALM (Commercial Advertisement Loudness Mitigation) ACT CERTIFICATION / FCC RULES'
                            }
                            blurb={
                                'We certify that our programming is compliant with the ATSC A/85 Recommended Practice for commercial loudness and its implementing rules.'
                            }
                        />
                    )}
                </div>
            </div>
        );
    }
}

EntertainmentView.propTypes = {
    className: PropTypes.string,
    adContentId: PropTypes.string,
    pathName: PropTypes.string,
    personalityData: PropTypes.object,
    context: PropTypes.oneOf(['shows', 'personalities']).isRequired,
    tiles: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string,
            imgCuts: PropTypes.string,
            title: PropTypes.string,
            blurb: PropTypes.string,
            alt: PropTypes.string,
            url: PropTypes.string,
            urlText: PropTypes.string
        })
    )
};

EntertainmentView.defaultProps = {
    className: 'entertainment__body',
    pathName: '',
    tiles: []
};

export default EntertainmentView;
